import React, { useEffect } from 'react'
import { useWebSocketContext } from '../../contexts/WebSocketContext'
import './NotificationToast.css'

const Icons = {
  Success: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  Warning: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  Info: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  ),
  Error: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  ),
  Close: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
}

const NotificationToast: React.FC = () => {
  const { notifications, dismissNotification } = useWebSocketContext()

  // Auto-dismiss after 5 seconds
  useEffect(() => {
    if (notifications.length === 0) return

    const timers = notifications.map(notification => {
      return setTimeout(() => {
        dismissNotification(notification.id)
      }, 5000)
    })

    return () => {
      timers.forEach(timer => clearTimeout(timer))
    }
  }, [notifications, dismissNotification])

  if (notifications.length === 0) return null

  const getIcon = (type: string) => {
    switch (type) {
      case 'success':
        return <Icons.Success />
      case 'warning':
        return <Icons.Warning />
      case 'error':
        return <Icons.Error />
      default:
        return <Icons.Info />
    }
  }

  return (
    <div className="notification-toast-container">
      {notifications.slice(0, 3).map((notification) => (
        <div
          key={notification.id}
          className={`notification-toast notification-toast--${notification.type}`}
        >
          <div className="notification-toast__icon">
            {getIcon(notification.type)}
          </div>
          <div className="notification-toast__content">
            <h4 className="notification-toast__title">{notification.title}</h4>
            <p className="notification-toast__message">{notification.message}</p>
          </div>
          <button
            className="notification-toast__close"
            onClick={() => dismissNotification(notification.id)}
            aria-label="Dismiss"
          >
            <Icons.Close />
          </button>
        </div>
      ))}
    </div>
  )
}

export default NotificationToast
